export default class SharedService {
  constructor() {
    this.methodToCall = null;
  }

  setMethodToCall(method) {
    this.methodToCall = method;
  }

  callMethod(message) {
    if (this.methodToCall) {
      this.methodToCall(message);
    }
  }
}
